/* eslint-disable no-multi-str */
import React from "react"

import SectionContainer from "../components/SectionContainer"
import SkillViewBuilder from "./SkillViewBuilder"

import jsLogo from "../images/jslogo.png"
import htmlLogo from "../images/htmllogo.png"
import cssLogo from "../images/csslogo.png"
import tsLogo from "../images/tslogo.png"
import jqueryLogo from "../images/jquerylogo.png"
import reactLogo from "../images/reactlogo2.png"
import reduxLogo from "../images/reduxlogo.png"
import routerLogo from "../images/reachlogo.png"
import styledLogo from "../images/styledlogo.png"
import framerLogo from "../images/framerlogo.png"
import vueLogo from "../images/vuelogo.png"

const skills = [
  { 
    name: "JavaScript",
    icon: jsLogo,
    proficiency: "Proficient",
    description: "The language of the web",
    customtext: "I've used JavaScript for many projects of many \
                different scales - at work, for hobby projects, as \
                well as in academic settings. These days TypeScript is \
                my go-to language to build quick prototypes & write scripts.",
    related: [
      {
        name: "HTML5",
        icon: htmlLogo,
        proficiency: "Proficient",
      },
      {
        name: "CSS3",
        icon: cssLogo,
        proficiency: "Proficient",
      },
      {
        name: "TypeScript",
        icon: tsLogo,
        proficiency: "Proficient",
      },
      {
        name: "jQuery",
        icon: jqueryLogo,
        proficiency: "Familiar",
      },
    ]
  },
  {
    name: "React",
    icon: reactLogo,
    proficiency: "Proficient",
    description: "Industry-choice JavaScript library for building user interfaces",
    customtext: "React is my preferred choice for building web \
                applications. It was the first software development \
                library I learned and the one I have the most experience \
                with. I've also taught React to other developers at \
                work on several occasions.",
    related: [
      {
        name: "Redux",
        icon: reduxLogo,
        proficiency: "Proficient",
      },
      {
        name: "Reach Router",
        icon: routerLogo,
        proficiency: "Proficient",
      },
      {
        name: "Styled Components",
        icon: styledLogo,
        proficiency: "Proficient",
      },
      {
        name: "Framer Motion",
        icon: framerLogo,
        proficiency: "Familiar",
      },
    ]
  },
  {
    name: "Vue",
    icon: vueLogo,
    proficiency: "Proficient",
    description: "Popular and Incrementally Adoptable JavaScript framework",
    customtext: "I use Vue when I'm working with programmers who are \
                less experienced with web development. It's easier to teach, \
                tends to require less dependencies and is quite powerful and flexible",
  },
]

const WebSkills = () => (
  <SectionContainer header="Web">
    <SkillViewBuilder skills={skills}/>
  </SectionContainer>
)

export default WebSkills